module.exports = __webpack_public_path__ + "static/media/lottewelten.08f76e9e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/lottewelten.webp
// module id = 483
// module chunks = 0